import { forwardRef, useMemo } from 'react';
import OutlinedInput, { type OutlinedInputProps } from '@material-ui/core/OutlinedInput';

import { useCursorPositionFix } from 'src/lib/hooks/useCursorPositionFix';

interface Props extends OutlinedInputProps {
  inputProps?: Record<string, unknown>;
  disallowLogRocket?: boolean;
  dataTestId?: string;
}

export const CustomInput = forwardRef<HTMLInputElement, Props>(
  ({ inputProps, disallowLogRocket, dataTestId, value, onChange, ...restProps }, ref) => {
    const localInputProps = useMemo(
      () => ({
        ...inputProps,
        'data-testid': dataTestId,
        'data-private': disallowLogRocket ? '' : null,
        dir: 'auto',
      }),
      [inputProps, disallowLogRocket, dataTestId]
    );

    const { value: fixedValue, onChange: fixedOnChange } = useCursorPositionFix(value, onChange);

    return (
      <OutlinedInput
        ref={ref}
        inputProps={localInputProps}
        value={fixedValue}
        onChange={fixedOnChange}
        {...restProps}
      />
    );
  }
);
